import config from 'config';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import locales from './locales';

// Imported first by the app entry on purpose: `components/AIAssistant/shared/utils.ts`
// and `utils/tipTapEditor/SlashCommandExtension.ts` call `i18next.t` at module scope,
// and before `init` runs `t()` returns undefined, silently blanking every title they
// bake in. `nsSeparator`/`keySeparator: false` keep the natural-language keys whole —
// 415 of them contain `.` and 45 contain `:`.
i18next.use(initReactI18next).init({
	debug: config.i18next.debug,
	nsSeparator: false,
	keySeparator: false,
	interpolation: {
		escapeValue: false,
	},
	lng: 'de',
	resources: {
		de: {
			translation: locales.de,
		},
	},
});
